import React, { ReactNode, TableHTMLAttributes } from "react";

import styles from "./SummaryTable.module.scss";

type Table = Omit<Partial<TableHTMLAttributes<HTMLTableElement>>, "className" | "children">;

type Props = Table & {
  children: ReactNode;
};

export const SummaryTable = (props: Props) => <table {...props} className={styles.summaryTable} />;
